// Web: export the actual heic2any module
import heic2any from 'heic2any'
export default heic2any
